import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Category} from '../models';

@Injectable()
export class CategoryService extends IoService {
  protected model = Category;
  protected listUrl = '/categories/';
}
